import { AppButton, AppFieldGroup, AppInput } from '../../ui-foundation';
import { type IsoDateBounds } from '../../ui-foundation/core';

type AppDateFieldProps = {
  label: string;
  value: string | null | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  helper?: string;
  allowClear?: boolean;
} & IsoDateBounds;

export default function AppDateField({
  label,
  value,
  onChange,
  placeholder = 'Pick a date',
  helper,
  minimum,
  maximum,
  disableFuture,
  allowClear = true,
}: AppDateFieldProps) {
  const today = new Date().toISOString().slice(0, 10);
  const maximumValue = disableFuture ? today : maximum;

  return (
    <AppFieldGroup label={label}>
      <div className="space-y-2">
        <AppInput
          tag="input"
          type="date"
          value={value || ''}
          min={minimum}
          max={maximumValue}
          placeholder={placeholder}
          onChange={(event) => onChange((event.target as HTMLInputElement).value)}
        />
        {helper ? (
          <p className="text-xs leading-relaxed text-muted-foreground">{helper}</p>
        ) : null}
        {allowClear && value ? (
          <div className="flex justify-end">
            <AppButton
              type="button"
              tone="ghost"
              size="sm"
              onPress={() => onChange('')}
            >
              Clear date
            </AppButton>
          </div>
        ) : null}
      </div>
    </AppFieldGroup>
  );
}
